export enum InternationalInsuranceVehicleTypeEnum {
    Caravan = 'Caravan',
    Trailer = 'Trailer',
}
